var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1246",
    "data-name": "Group 1246",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.32,
    height: 29.32,
    viewBox: "0 0 29.32 29.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M0,0H29.32V29.32H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M3,7.443A2.443,2.443,0,0,1,5.443,5h17.1A2.443,2.443,0,0,1,24.99,7.443V19.66A2.443,2.443,0,0,1,22.547,22.1H5.443A2.443,2.443,0,0,1,3,19.66Z",
    transform: "translate(0.665 1.108)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M3,7l11,7.33L24.99,7",
    transform: "translate(0.665 1.552)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/e-mail.7021ac92f2724ea95106b17a82846057.svg";
export { ForwardRef as ReactComponent };